<router-outlet></router-outlet>

<div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-child-name" class="modal-title pull-left">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          Session Timeout
        </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="hideChildModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mrgbtm">
          <div class="col-md-12">
            <p>You will be logged out soon due to inactivity.</p>
            <p>{{ idleState }}</p>
            <button type="button" (click)="stay()" class="btn btn-success">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
